import { baseThunkConfig, createAppSlice } from '@exp/redux/createAppSlice';

import { getCarts } from '../api/checkout';
import { deleteUserProductTaxonomy, getUserProductTaxonomy, postUserProductTaxonomy } from '../api/profile';
import { getTeamFavorites } from '../api/team';

/**
 * Personalization Slice
 */
const personalizationSlice = createAppSlice({
  initialState: {},
  name: 'personalization',
  reducers: (create) => ({
    fetchCoupons: create.asyncThunk(() => getCarts(), {
      ...baseThunkConfig,
      fulfilled: (state, action) => {
        const coupons = (action.payload?.coupons || []).toSorted((a, b) => b.endDate - a.endDate);
        state.coupons = coupons;
      },
    }),
    fetchTeamFavorites: create.asyncThunk((teamId) => getTeamFavorites(teamId), {
      ...baseThunkConfig,
      fulfilled: (state, action) => {
        state.teamFavorites = action.payload;
      },
    }),
    fetchUserFavorites: create.asyncThunk(() => getUserProductTaxonomy(), {
      ...baseThunkConfig,
      fulfilled: (state, action) => {
        state.userFavorites = action.payload?.selectedProductTaxonomyIds || [];
      },
    }),
    saveUserFavorite: create.asyncThunk((productTaxonomyId) => postUserProductTaxonomy(productTaxonomyId)),
    deleteUserFavorite: create.asyncThunk((productTaxonomyId) => deleteUserProductTaxonomy(productTaxonomyId)),
  }),
  selectors: {
    selectCoupons: (state) => state.coupons,
    selectTeamFavorites: (state) => state.teamFavorites,
    selectUserFavorites: (state) => state.userFavorites,
  },
});

export const { deleteUserFavorite, fetchCoupons, fetchTeamFavorites, fetchUserFavorites, saveUserFavorite } =
  personalizationSlice.actions;

export const { selectCoupons, selectTeamFavorites, selectUserFavorites } = personalizationSlice.selectors;

export default personalizationSlice;
